'use strict';

import util from '../util';
import pdfUtils from '../pdfUtils';

var initOrderReturn = function() {
	
    $('.return-qty').on('change', onQtyChange);
    $('.productReturn button#return').on('click', onReturnSubmit);
	
    $('.returnreason').on('change', function() {
        if($(this).find('.returnreason').val() != 'Select Reason') {
            $(this).parents().eq(2).find('.reason-error').hide();
        }
    });
	
    $('.download-return-invoice').on('click', downloadReturnInvoice);
}

function onQtyChange() {
    var totalQty = calculateTotalQty(this);
    $('.returnQuantity').text(totalQty);
}

function calculateTotalQty(elem) {
    var totalQty = 0;
    $('.return-qty').each(function() {
        totalQty = totalQty + Number($(this).val());
    });
	
    if(totalQty > 0) {
        $('.return-button-error').hide();
    } else {
        $(elem).parents().eq(1).find('.reason-error').hide();
    }
	
    return totalQty;
}

function onReturnSubmit() {
    var totalQty = calculateTotalQty(); 
    var isError = false;
	
    if(totalQty == 0) {
        $('.return-button-error').show();
        isError = true;
    } else {
		
        $('.ordered-items .item-detail-row').each(function() {
            if($(this).find('.return-qty').val() > 0) {
                if($(this).find('.returnreason').val() == 'Select Reason') {
                    $(this).find('.reason-error').show();
                    isError = true;
					
                }
            }
			
            if($(this).find('.returnreason').val() != 'Select Reason') {
                if($(this).find('.return-qty').val() == 0) {
                    $(this).find('.item-qty-error').show();
                    isError = true;
                }
            }
        });
    }
	
    var commentMessage = $('textarea[name*="returnComments"]').val();
    if(commentMessage != '') {
        if (!util.validateMessage(commentMessage)) {
            $('.commentserror').show();
            isError = true;
        } else {
            $('.commentserror').hide();
        }
    }
	
    if(isError) {
        return false;
    }
	
	
}

function downloadReturnInvoice(e) {
    e.preventDefault();
	
    var invoiceURL = $(this).attr('href');
    $.ajax({
    	url : invoiceURL,
    	type : 'GET'
    }).then(function(response){
    	
    	var doc = new jsPDF('l', 'pt', 'a4');
    	var invoiceNumber = $(response).find('#invoice-number-pdf');
    	var invoiceAddress = $(response).find('#invoice-address-pdf');
    	var orderNumber = $(response).find('#page-intro-pdf');
    	var orderDate = $(response).find('#order-date-pdf');
    	var invoiceDate = $(response).find('#invoice-date-pdf');
    	var invoiceEmeaTaxNumber = $(response).find('#invoice-emea-tax-number-pdf');
        var invoiceSubsidiaryInformation = $(response).find('#invoice-subsidiary-information-pdf address');
        var cardImageEle = $(response).find('.payment-block .logo').get(0);
        var idInfo = $(response).find('.id-documents');
    	
    	//Order Table Data Push
    	var orderTableColumn = new Array();
    	$(response).find('.address-method-payment-table-column').each(function() {
    		orderTableColumn.push($(this).text().trim().replace(/\s+/g, ' '));
    	});
    	orderTableColumn.push('');
    	
    	var orderTableRows = new Array();
    	var orderTableRow = new Array();
    	var i = 0;
    	$(response).find('.address-method-payment-table-row').each(function() {
    		if(cardImageEle != null && i == 3) {
    			orderTableRow.push('');
    		}
    		orderTableRow.push($(this).text().trim());
    		i++;
    	});
    	
    	orderTableRows.push(orderTableRow);
    	
    	//Product Table Data Push
    	var productTableColumn = new Array();
    	$(response).find('.table-header span').each(function() {
    		productTableColumn.push($(this).text().trim().replace(/\s+/g, ' '));
    	});
    	
    	var productTableRows = new Array();
    	
    	$(response).find('.table-rows').each(function() {
    		var productTableRow = new Array();
    		
    		$(this).find('span').each(function() {
    			productTableRow.push($(this).text().trim().replace(/\s+/g, ' '));
        	});
    		
    		productTableRows.push(productTableRow);
    	});
    	
    	//Order Total Data Push
    	var orderTotalsColumn = new Array();
    	orderTotalsColumn.push('');
    	orderTotalsColumn.push('');
    	
    	var orderTotalsRows = new Array();
    	
    	$(response).find('.calculations-container div.clearfix').each(function() {
    		var orderTotalRow = new Array();
    		
    		var line1 = $(this).find('.order-label-pdf').text().trim().replace(/\s+/g, ' ');
    		var line2 = $(this).find('.order-value-pdf').text().trim().replace(/\s+/g, ' ');
    		
    		orderTotalRow.push(line1);
    		orderTotalRow.push(line2);
    		
    		orderTotalsRows.push(orderTotalRow);
    	});
    	
    	var narsLogoEle = $(response).find('#pdf-nars-logo').get(0);
    	
    	var pdfInvoiceNumberText = pdfUtils.getElementHtmlTrim(invoiceNumber);
    	var pdfInvoiceAddressText = pdfUtils.getElementHtmlTrim(invoiceAddress);
        var pdfOrderNumberText = pdfUtils.getElementHtmlTrim(orderNumber);
        var pdfOrderDateText = pdfUtils.getElementHtmlTrim(orderDate);
        var pdfInvoiceDateText = pdfUtils.getElementHtmlTrim(invoiceDate);
        var pdfInvoiceEmeaTaxNumber = pdfUtils.getElementHtmlTrim(invoiceEmeaTaxNumber);
        var pdfInvoiceSubsidiaryInformation = pdfUtils.getElementHtmlTrim(invoiceSubsidiaryInformation);
        var idDocuments = pdfUtils.getElementHtmlTrim(idInfo);
		
        //emea tax invoice info
        var emeaTaxCol = [''],
            taxInfo1 = [invoiceEmeaTaxNumber.text().trim().replace(/\s+/g, ' ')],
            taxInfo2 = [invoiceSubsidiaryInformation.html().trim().replace(/\s+/g, ' ')],
            subSidiaryStr = invoiceSubsidiaryInformation.html().split('<br>'),
            emeaTaxRows	= [];
        $.each(subSidiaryStr, function(index, value){
            var subSidiaryAdd = [];
            subSidiaryAdd.push(value.replace(/\s+/g, ' '));
            emeaTaxRows.push(subSidiaryAdd);
        })
		
        delay(function(){
            var pdfcardImageBase64 = getBase64Image(cardImageEle);
            var imgData = getBase64Image(narsLogoEle);
            generateReturnInvoicePDF(doc, imgData, pdfInvoiceNumberText, pdfInvoiceAddressText, pdfcardImageBase64, 
                pdfOrderNumberText, pdfOrderDateText, pdfInvoiceDateText, pdfInvoiceEmeaTaxNumber,
                pdfInvoiceSubsidiaryInformation, orderTableColumn, orderTableRows, 
                productTableColumn, productTableRows, orderTotalsColumn, orderTotalsRows, emeaTaxCol, emeaTaxRows, idDocuments);
        }, 700); 
		
		
    });
}

var delay = (function() {
    var timer = 0;
    return function(callback, ms) {
        clearTimeout(timer);
        timer = setTimeout(callback, ms);
    };
})();

function getBase64Image(img) {
    var canvas = document.createElement('canvas');
    canvas.width = img.width;
    canvas.height = img.height;
    var ctx = canvas.getContext('2d');
    ctx.drawImage(img, 0, 0);
    var dataURL = canvas.toDataURL('image/png');
    return dataURL.replace(/^data:image\/(png|jpg);base64,/, '');
}


function generateReturnInvoicePDF(doc, imgData, pdfInvoiceNumberText, pdfInvoiceAddressText, pdfcardImageBase64, 
    pdfOrderNumberText, pdfOrderDateText, pdfInvoiceDateText, pdfInvoiceEmeaTaxNumber,
    pdfInvoiceSubsidiaryInformation, orderTableColumn, orderTableRows, 
    productTableColumn, productTableRows, orderTotalsColumn, orderTotalsRows, emeaTaxCol, emeaTaxRows, idDocuments) {
	
    doc.page=1;
	
    //Logo and Invoice Number
    doc.addImage(imgData, 'PNG', 18, 20, 150, 75);
    doc.fromHTML(pdfInvoiceNumberText, 20, 100);
    doc.fromHTML(idDocuments, 180, 75);
	
    //Invoice Address
    var addHtml = $.parseHTML(pdfInvoiceAddressText)[0].innerHTML,
        addLeftPos = 620, 
        htmlArray = addHtml.split('<br>');
	
    $.each(htmlArray, function(i, j){
        if(j.length > 35)
            addLeftPos = 490;
    })
    doc.fromHTML(pdfInvoiceAddressText, addLeftPos, 20, {'width': 425});
	
    //Payment Text, Image and Value
    doc.addImage(pdfcardImageBase64, 'PNG', 475, 185, 48.75, 30.75);
	
    //Order Number, Order Date, Invoice Date
    doc.fromHTML(pdfOrderNumberText, 25, 285);
    doc.fromHTML(pdfOrderDateText, 195, 285);
    doc.fromHTML(pdfInvoiceDateText, 350, 285);
	
    //Table - Shipping, Billing and Payment
    doc.autoTable(orderTableColumn, orderTableRows, {theme: 'plain',
        styles:{cellPadding: 5, overflow: 'linebreak'},
        columnStyles: {
            0: {columnWidth: 150},
            1: {columnWidth: 150},
            2: {columnWidth: 150},
            3: {columnWidth: 60},
            4: {columnWidth: 150}
        },
        startY: false,
        margin: {top: 155, left: 20}
    });
	
    //Order Total table
    doc.autoTable(orderTotalsColumn, orderTotalsRows, {theme: 'plain',
        columnStyles:{
            0: {columnWidth: 150, halign: 'left'},
            1: {columnWidth: 50, halign: 'right'}
        },
        styles:{columnWidth: 150, overflow: 'linebreak'}, 
        margin: {top: 325, left: 630},
        createdCell: function(cell, data) {
            if (data.row.index === 3) { 
                cell.styles.fontStyle = 'bold';
            }
        }
    });
	
    var totalPages = 1;
    if(productTableRows.length > 6) {
	 	totalPages = 2;
    }

    doc.setFontSize(8);
    doc.text(400, 580, Resources.INVOICE_PAGE + doc.page +' '+ Resources.INVOICE_OF +' '+ totalPages);
    doc.page ++;

    //Product list table
    doc.autoTable(productTableColumn, productTableRows, {theme: 'striped',
        columnStyles: {
            0: {columnWidth: 230, halign: 'left'},
            1: {columnWidth: 74},
            2: {columnWidth: 74},
            3: {columnWidth: 74},
            4: {columnWidth: 55},
            5: {columnWidth: 75}
        },
        styles:{
            halign: 'center',
            overflow: 'linebreak'
        },
        headerStyles:{
            halign: 'left',
            fillColor: [0, 0, 0],
            textColor: [255, 255, 255]
        },
        startY: 350,
        margin: {top: 20, left: 20, bottom: 80}
    });
	
    if(productTableRows.length > 6) {
        doc.text(400, 580, Resources.INVOICE_PAGE + doc.page +' '+ Resources.INVOICE_OF +' '+ totalPages);
    }
	
    //EMEA Tax Number, Name, Group Address table
	
    doc.autoTable(emeaTaxCol, emeaTaxRows, {theme: 'plain', 
        columnStyles: {
            0: {halign: 'center'}
        },
        tableWidth: 'auto',
        showHeader: '',
        headerStyles: {
            halign: 'center'
        },
        styles:{
            overflow: 'linebreak',
            cellPadding: 1,
            fontSize: 10
        },
        startY: 528,
        margin: {top: 30, left: 20}
    });
	
    //pdf generation and file creation
    doc.save('ReturnInvoice.pdf');
}

export default {
    init: function () {
        initOrderReturn();
    }
};
